export default __webpack_public_path__ + "static/media/logo-spotterful-employers.484c1927.png";